import { initialize } from 'redux-form/immutable';

import * as ActionDefinitions from './actionDefinitions';

import { createAction } from '../../utils/redux-helper';

export const FORM_STEP1 = 'step1';
export const FORM_STEP2 = 'step2';
export const FORM_STEP3 = 'step3';
export const FORM_STEP4 = 'step4';
export const FORM_STEP5 = 'step5';

export const goToStep = (step) => {
  const payload = {
    step
  };
  return createAction(ActionDefinitions.GOTO_STEP, payload);
};

export const goToPrevStep = () => {
  const payload = {};
  return createAction(ActionDefinitions.GOTO_PREV_STEP, payload);
};

export const goToNextStep = () => {
  const payload = {};
  return createAction(ActionDefinitions.GOTO_NEXT_STEP, payload);
};

export const initializeSpecificForm = (numStep, data) => dispatch => {
  dispatch(initialize(numStep, data));
};

export const setConvention = (name, validity) => {
  const payload = {
    name,
    validity
  };
  return createAction(ActionDefinitions.SET_CONVENTION, payload);
};

export const setPrivacyInfo = (data) => {
  return createAction(ActionDefinitions.SET_PRIVACY_INFO, data);
};

export const setProducts = (products) => {
  const payload = {
    products
  };
  return createAction(ActionDefinitions.SET_PRODUCTS, payload);
};
